<div class="actions">
    <idel-rounded-button [icon]="'bi bi-search'" (click)="actionClick.emit('search')" [outlined]="false"
        [severity]="'success'" [tooltip]="'Rechercher'" [tooltipPosition]="'left'"></idel-rounded-button>
    <idel-rounded-button [icon]="'bi bi-x'" (click)="actionClick.emit('cancel')" [outlined]="false"
        [severity]="'danger'" [tooltip]="'Annuler la recherche'" [tooltipPosition]="'left'"></idel-rounded-button>
    <idel-rounded-button [icon]="'bi bi-floppy-fill'" (click)="actionClick.emit('save')" [outlined]="true"
        [tooltip]="'Sauver'" [disabled]="!canSave()" [tooltipPosition]="'left'"></idel-rounded-button>
    <idel-rounded-button [icon]="'bi bi-arrow-counterclockwise'" (click)="actionClick.emit('reinit')" [outlined]="true"
        [tooltip]="'Réinitialiser'" [tooltipPosition]="'left'"></idel-rounded-button>
</div>